// new submodule
export default {
	/**
	 * init all my_group functions
	 */
	init() {
		// remove active status from template links, then mark current template link as active
		$("a.j-template-gap-sandbox-link").on("click", function () {
			const $elem = $(this);

			pp.viewHelpers.replaceDropdownTriggerText($elem);
			pp.viewHelpers.manageDropdownActiveState($elem);

			$(".j-text-gap-draft-container").addClass("hidden");

			$(
				`.j-text-gap-draft-container[data-article-id='${$elem.attr("data-article-id")}']`,
			).removeClass("hidden");
			// init select2
			pp.global.initSelect2For($("div.text-gap-draft:visible").find("select"));
		});

		// For the horizontal (= not dropdown) links on top of the shared workspace
		$(".group-right .Module__content__inline-menu a").on("click", function () {
			const $elem = $(this);
			$elem.closest("ul").find("a").parent().removeClass("active");
			$elem.parent().addClass("active");
		});
	},
};
